import React , { Component } from 'react';
import ReactDOM from 'react-dom';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import $ from 'jquery';

class AccordionLayout extends Component{
    constructor(props){
        super(props);

        this.state={
            accordion:false
        }
        this.handleChange =this.handleChange.bind(this);
    }


    getTitleContent(){
        if(this.props.titleContent){
           return <div>{this.props.titleContent} <span className="acc_close"><i className="material-icons">add</i></span></div>;
        }else{
            return <div>Accordian Title <span className="acc_close"><i className="material-icons">add</i></span></div>
        }
    }

    getBodyContent(){
        if(this.props.bodyContent){
            return this.props.bodyContent;
        }else{
            return <div>Accordian Body</div>
        }
    }
    
    handleChange(e){
        var me=this;
        const node  = ReactDOM.findDOMNode(this);

        let child = null;
        if(node && node instanceof HTMLElement){
           child = (node.children && node.children.length > 0) ? node.children[0] : null;
           //console.log("Accordian Triggered ",child);
        }
        
        if(child && this.state.accordion){
            $(child).find(".acc_close").removeClass("minus");
            $(child).find(".acc_close").addClass("plus");
            $(child).find(".acc_close").html('<i class="material-icons">add</i>');
            me.setState({accordion:false})
        }else if(child){
            $(child).find(".acc_close").removeClass("plus");
            $(child).find(".acc_close").addClass("minus");
            $(child).find(".acc_close").html('<i class="material-icons">remove</i>');
            me.setState({accordion:true})
        }
    }             
    
    render(){
        return (
            <Accordion id="AccordionLayout" onChange={this.handleChange}>
                <AccordionItem expanded={this.props.expanded || false}>

                <AccordionItemTitle>
                {this.getTitleContent()}
                </AccordionItemTitle>
                    
                <AccordionItemBody>
                {this.getBodyContent()}
                </AccordionItemBody>

            </AccordionItem>
            </Accordion>
        )
    }
}

export default AccordionLayout;


// WEBPACK FOOTER //
// ./src/vendors/prep/AccordionLayout.js